export const ru: Record<string, string> = {
  // Nav
  'nav.dashboard': 'Панель',
  'nav.products': 'Товары',
  'nav.tasks': 'Задачи',
  'nav.approvals': 'Одобрения',
  'nav.actions': 'Действия',
  'nav.settings': 'Настройки',

  // Auth
  'auth.signin': 'Войти',
  'auth.signing_in': 'Вход...',
  'auth.email': 'Email',
  'auth.password': 'Пароль',
  'auth.signout': 'Выйти',

  // Dashboard
  'dashboard.title': 'Панель управления',
  'dashboard.sync': 'Синхронизация каталога',
  'dashboard.sync_catalog': 'Синхронизировать каталог',
  'dashboard.run_analysis': 'Запустить анализ',
  'dashboard.syncing': 'Синхронизация...',
  'dashboard.analyzing': 'Анализ...',
  'dashboard.score_distribution': 'Распределение оценок',
  'dashboard.common_issues': 'Частые проблемы',
  'dashboard.summary': 'Сводка',
  'dashboard.store_health': 'Здоровье магазина',
  'dashboard.health_trend': 'Тренд здоровья',
  'dashboard.total_products': 'Всего товаров',
  'dashboard.avg_score': 'Средняя оценка',

  // Products
  'products.title': 'Товары',
  'products.loading': 'Загрузка товаров...',
  'products.empty': 'Товары не найдены. Попробуйте синхронизировать каталог.',
  'products.filter_category': 'Фильтр по категории...',
  'products.score_breakdown': 'Детализация оценок',
  'products.back': 'Назад',
  'products.not_analyzed': 'Не проанализирован',

  // Tasks
  'tasks.title': 'Задачи',
  'tasks.new': 'Новая задача',
  'tasks.create': 'Создать задачу',
  'tasks.creating': 'Создание...',
  'tasks.goal': 'Цель',
  'tasks.max_products': 'Макс. товаров',
  'tasks.max_score': 'Макс. оценка',
  'tasks.tone': 'Тон (необязательно)',
  'tasks.preserve_html': 'Сохранить HTML форматирование',
  'tasks.approval_mode': 'Режим одобрения',
  'tasks.manual': 'ручной',
  'tasks.assisted': 'автоматический',
  'tasks.approve_plan': 'Одобрить план',
  'tasks.reject': 'Отклонить',
  'tasks.pause': 'Пауза',
  'tasks.resume': 'Продолжить',
  'tasks.cancel': 'Отменить задачу',
  'tasks.diagnostic': 'Диагностика',
  'tasks.plan': 'План',
  'tasks.steps': 'Шаги',
  'tasks.changes': 'Изменения',
  'tasks.results': 'Результаты',

  // Approvals
  'approvals.title': 'Одобрения',
  'approvals.loading': 'Загрузка одобрений...',
  'approvals.empty': 'Нет ожидающих одобрений. Все чисто!',
  'approvals.approve': 'Одобрить',
  'approvals.reject': 'Отклонить',
  'approvals.already_decided': 'Уже решено из другого интерфейса',

  // Actions
  'actions.title': 'Журнал действий',
  'actions.loading': 'Загрузка действий...',
  'actions.empty': 'Действий пока нет.',
  'actions.rollback': 'Откатить',
  'actions.rolling_back': 'Откат...',
  'actions.expired': 'Истекло',

  // Settings
  'settings.title': 'Настройки',
  'settings.account': 'Аккаунт',
  'settings.credentials': 'Учетные данные Bitrix',
  'settings.test_connection': 'Проверить подключение',
  'settings.save': 'Сохранить',
  'settings.testing': 'Проверка...',
  'settings.saving': 'Сохранение...',
  'settings.webhook_url': 'URL вебхука',
  'settings.catalog_id': 'ID каталога',
  'settings.price_type_id': 'ID типа цены',
  'settings.review_id': 'ID отзывов (необязательно)',
  'settings.portal_config': 'Конфигурация портала',
  'settings.portal_connected': 'Подключен через Bitrix24',
  'settings.select_catalog': 'Выберите каталог...',
  'settings.select_price_type': 'Выберите тип цены...',
  'settings.save_config': 'Сохранить конфигурацию',
  'settings.redetect': 'Обнаружить заново',
  'settings.config_saved': 'Конфигурация сохранена',

  // Subscription
  'subscription.title': 'Подписка',
  'subscription.plan': 'Тариф',
  'subscription.status_active': 'Активна',
  'subscription.status_trial': 'Пробный период',
  'subscription.status_expired': 'Истекла',
  'subscription.products_usage': 'Товары',
  'subscription.tasks_usage': 'Задачи за месяц',
  'subscription.unlimited': 'Безлимитно',
  'subscription.expires': 'Истекает',
  'subscription.upgrade': 'Улучшить тариф',

  // Telegram
  'telegram.connect_title': 'Подключите Telegram',
  'telegram.connect_description':
    'Сканируйте QR-код или нажмите кнопку, чтобы подключить Telegram-бота для управления магазином',
  'telegram.open_in_telegram': 'Открыть в Telegram',
  'telegram.qr_expiry': 'QR-код действителен 10 минут',
  'telegram.connected': 'Telegram подключен',
  'telegram.not_connected': 'Telegram не подключен',
  'telegram.reconnect': 'Подключить заново',
  'telegram.generating': 'Генерация ссылки...',
  'telegram.manage_via_bot': 'Управляйте магазином через @SalesAutopilot_bot',
  'telegram.generate_error': 'Не удалось сгенерировать ссылку. Попробуйте ещё раз.',

  // Orders
  'orders.title': 'Заказы',
  'orders.loading': 'Загрузка заказов...',
  'orders.empty': 'Заказов пока нет.',
  'orders.total_count': 'заказов',
  'orders.number': 'Номер',
  'orders.date': 'Дата',
  'orders.customer': 'Покупатель',
  'orders.status': 'Статус',
  'orders.total': 'Сумма',
  'orders.order': 'Заказ',
  'orders.not_found': 'Заказ не найден',
  'orders.items': 'Товары',
  'orders.item_name': 'Наименование',
  'orders.quantity': 'Кол-во',
  'orders.price': 'Цена',
  'orders.item_total': 'Итого',
  'orders.payment': 'Оплата',
  'orders.shipment': 'Доставка',

  // Low Stock
  'low_stock.title': 'Мало на складе',
  'low_stock.and_more': 'и ещё ${count}',

  // Weekly Trends
  'weekly_trends.title': 'Тренды за неделю',
  'weekly_trends.avg_revenue': 'Средняя выручка',
  'weekly_trends.total_orders': 'Всего заказов',
  'weekly_trends.top_day': 'Лучший день',

  // Store Status
  'store_status.title': 'Статус магазина',
  'store_status.orders': 'Заказы',
  'store_status.revenue': 'Выручка',
  'store_status.avg_order': 'Средний чек',
  'store_status.today': 'Сегодня',
  'store_status.details_in_telegram': 'Подробнее в Telegram — /today',
  'store_status.no_data': 'Нет данных о продажах',

  // Common
  'common.loading': 'Загрузка...',
  'common.coming_soon': 'Скоро',
  'common.error': 'Ошибка',
  'common.try_again': 'Попробовать снова',
  'common.previous': 'Назад',
  'common.next': 'Далее',
  'common.page': 'Страница',
  'common.of': 'из',
};
